import React from 'react';
export function Header() {
  return <header className="max-w-3xl mx-auto px-4 pt-12 pb-8 text-center" data-id="element-16">
      <div className="flex justify-center mb-8" data-id="element-17">
        <img src="https://cdn.magicpatterns.com/uploads/bvcDK2cMR9Zvb2aVFE1uhv/hf_20260615_145856_fb83ee69-0e23-4237-98e1-e102f994705a.png" alt="Augenpartie einer Frau vorher und nachher im Vergleich" className="w-full max-w-md rounded-2xl shadow-md object-cover" data-id="element-18" />
      </div>

      <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold leading-tight mb-6 text-slate-900" data-id="element-19">
        Was Stiftung Warentest nicht offen ausspricht: 5 Wahrheiten über
        Augenringe und Tränensäcke nach 40 — und was Hautärztinnen in München
        und Wien jetzt stattdessen empfehlen
      </h1>

      <p className="text-lg sm:text-xl text-slate-600 font-medium mb-8 max-w-2xl mx-auto" data-id="element-20">
        Eine 9-minütige Lektüre für Frauen, die alles versucht haben und es leid
        sind, belogen zu werden.
      </p>

      <div className="flex items-center justify-center gap-3 text-left" data-id="element-21">
        <img src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?auto=format&fit=crop&q=80&w=200" alt="Dr. med. Annika Vogt" className="w-12 h-12 rounded-full object-cover border-2 border-brand-200" data-id="element-22" />
        <div data-id="element-23">
          <div className="font-bold text-slate-900" data-id="element-24">Dr. med. Annika Vogt</div>
          <div className="text-sm text-slate-500" data-id="element-25">
            Dermatologin, München & Wien • 14. Juni 2026
          </div>
        </div>
      </div>
    </header>;
}